import ThumbtackRating from '../thumbtackrating/thumbtackrating.vue';
import truncate from 'lodash/truncate';
import {mapGetters} from 'vuex';

export default {
    name: 'thumbtack-pro',
    props: ['provider'],
    components: {
        ThumbtackRating
    },
    data () {
        return {
            pillConfig: {
                low_price: { text: 'Great value', icon: 'cash', theme: 'default' },
                popular: { text: 'In high demand', icon: 'trend-up', theme: 'default' },
                licensed: { text: 'Licensed pro', icon: 'shield-check', theme: 'default' },
                remote: { text: 'Offers remote services', icon: 'live-connect', theme: 'default' },
                overserved: { text: 'Limited availability', icon: 'calendar', theme: 'yellow' }
            }
        };
    },
    methods: {
        truncate,
    },
    computed: {
        ...mapGetters('glb', ['glb','getSplit']),
        utmParam(){
            return window.location.search.split('&').find(item=>item.includes('utm_content')) || '';
        },
        formattedRating() {
            return this.provider.rating.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        },
        rating() {
            return parseFloat(this.formattedRating);
        },
        quote() {
            return this.provider.quote && this.provider.quote.starting_cost && this.provider.quote.cost_unit
                ? `$${(this.provider.quote.starting_cost / 100).toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                })}/${this.provider.quote.cost_unit}`
                : null;
        },
        ratingDescription() {
            return [
                { upper: 4.0, description: 'Good' },
                { upper: 4.7, description: 'Very good' },
                { upper: 4.9, description: 'Great' },
                { upper: 5.0, description: 'Excellent' },
                { upper: 5.1, description: 'Exceptional' }
            ].find(({ upper }) => this.rating < upper).description;
        },
        starRating() {

        }
    }
};
